import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3>About Company</h3>
              <p>
                Green Kleen is Oman's leading eco-friendly car care brand, specializing in waterless vehicle cleaning solutions.
                Established in 2010, we offer innovative, sustainable products and mobile services that conserve water and protect the environment.
                With 16 outlets across major cities, we deliver convenience, quality, and a greener future—one clean car at a time.
              </p>
              <div className="footer-social">
                <a href="https://www.instagram.com/greenkleen_om/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.facebook.com/GreenKleenOman/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
              </div>
            </div>
            
            <div className="footer-section">
              <h3>Our Links</h3>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/shop">Shop</Link></li>
                <li><Link to="/car-wash-trolley">Car Wash Trolley</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h3>Get In Touch</h3>
              <div className="footer-contact">
                <p><strong>Address:</strong> 11, Abu Sultan Investment, Rex Road, P.O Box 1797 PC 112, Ruwi, Muscat, Sultanate of Oman</p>
                <p><strong>Phone:</strong> +968 24708516</p>
                <p><strong>Email:</strong> <a href="mailto:contactus@greenkleenoman.com">contactus@greenkleenoman.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="footer-logo">
              <img src="img/logo/GreenKleen.logo.png" alt="Green Kleen Logo" />
            </div>
            <div className="footer-copyright">
              Copyright &copy; GreenKleen 2025. All rights reserved.
            </div>
            <div className="footer-legal">
              {/* <a href="/">Privacy</a>
              <a href="/">Term & Conditions</a>
              <a href="/">Legal</a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 